import React, { Suspense, useEffect, useState } from "react";
import { Routes, Route, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { onMessage } from "firebase/messaging";
import MainTheme from "../themes/main-theme";
import { AuthRoute, PrivateRoute } from "../themes/routeWrapper";
import MyAccountTheme from "../themes/myAccount-theme";
import * as Path from "./routesPath";
import useAuth from "../hooks/useAuth";
import { initializeMessaging } from "../firebase/config";
import LoginPop from "../Component/Modals/loginPop";
import { OverlayLoader } from "../Component/Loader";
// Page components
import Pagenotfound from "../Pages/404page";
import Home from "../Pages/home";
import Stories from "../Pages/stories";
import CommunityGuide from "../Pages/community";
import StoryDetails from "../Pages/storyDetails";
import Signin from "../Pages/Auth/Signin";
import Signup from "../Pages/Auth/Signup";
import ResetPassword from "../Pages/Auth/reset-password";
import Profile from "../Pages/myAccount/profile";
import PrivateDirectory from "../Pages/myAccount/privateDirectory";
import BookmarkedStories from "../Pages/myAccount/bookmarkedStories";
import ContactUs, { Faqs } from "../Pages/contactUs";
import MyQueries from "../Pages/myAccount/queries";
import OtherUserProfile from "../Pages/otherUserProfile";
import ContentPage from "../Pages/contentPage";
import Chat from "../Pages/chat";
import AddStory from "../Pages/addStory";
import QuotePop from "../Component/Modals/qoutePop";
import QuoteModal from "../Component/Modals/QuoteModal";

function MyRouts({ initialData = {} }) {
  const authData = useAuth();
  const isAuthenticated = initialData.usUserLoggedin ?? authData.isAuthenticated;

  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const receiver = searchParams.get("receiver");

  const { showLoginPop } = useSelector((state) => state.common);
  const { contentPagesList } = useSelector((state) => state.common || {});
  const [contentPages, setContentPages] = useState(initialData.cmsPages || []);

  const getAbsolutePath = (path) => {
    return path.replace("/", "");
  };

  useEffect(() => {
    try {
      if (typeof window !== "undefined") {
        onMessage(initializeMessaging(), (payload) => {
          const { title, body, icon, tag, click_url, type } = payload.data || {};
          const notificationOptions = { body, icon, tag };

          if (type === "message" && click_url.includes(receiver)) return;

          const notification = new Notification(title, notificationOptions);

          if (click_url || process.env.REACT_APP_WEBSITE_NAME) {
            notification.onclick = () => {
              window.open(click_url || process.env.REACT_APP_WEBSITE_NAME, "_blank");
            };
          }
        });
      }
    } catch (error) {
      console.log("firebase error", error);
    }
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (isAuthenticated && pathname.includes("auth")) {
      navigate(Path.homeRoute);
    }
  }, [pathname, isAuthenticated, navigate]);

  useEffect(() => {
    if (!initialData.cmsPages && contentPagesList) {
      setContentPages(contentPagesList);
    }
  }, [initialData, contentPagesList]);

  if (contentPages.length <= 0) return <OverlayLoader />;

  return (
    <div className="position-relative">
      {showLoginPop && <LoginPop />}

      <Suspense fallback={<OverlayLoader />}>
        <Routes onUpdate={() => window.scrollTo(0, 0)}>
          {/* Auth routes */}
          <Route onUpdate={() => window.scrollTo(0, 0)} path="/" element={<AuthRoute />}>
            <Route path={Path.signupRoute} element={<Signup />} />
            <Route path={Path.signinRoute} element={<Signin />} />
            <Route path={Path.resetPasswordRoute} element={<ResetPassword />} />
          </Route>

          {/* Public routes */}
          <Route
            onUpdate={() => window.scrollTo(0, 0)}
            path="/"
            element={<MainTheme initialData={initialData} />}>
            <Route index element={<Home initialData={initialData} />} />
            <Route path="/home" element={<Home initialData={initialData} />} />
            <Route path={Path.communitiesRoute} element={<CommunityGuide />} />
            <Route path={Path.storiesRoute} element={<Stories />} />
            <Route
              path={`${Path.storyDetailsRoute}/:storySlug/:storyId`}
              element={<StoryDetails initialData={initialData} />}
            />
            <Route path={Path.addStoryRoute} element={<AddStory />} />
            <Route path={`${Path.editStoryRoute}/:storyId`} element={<AddStory />} />
            <Route path={Path.contactUsRoute} element={<ContactUs />} />
            <Route path={Path.faqs} element={<Faqs initialData={initialData} />} />
            <Route
              path={`${Path.otherUserProfile}/:userSlug/:userId`}
              element={<OtherUserProfile initialData={initialData} />}
            />
            {contentPages?.map((page) => (
              <Route
                key={page.id}
                path={`/${page.slug}`}
                element={<ContentPage initialData={initialData} />}
              />
            ))}
          </Route>

          {/* Private routes */}
          <Route onUpdate={() => window.scrollTo(0, 0)} path="/" element={<PrivateRoute />}>
            <Route
              onUpdate={() => window.scrollTo(0, 0)}
              path={Path.myAccountRoute}
              element={<MyAccountTheme className="" />}>
              <Route
                path={getAbsolutePath(Path.privateRoutes.profileRoute)}
                element={<Profile />}
              />
              <Route
                path={getAbsolutePath(Path.privateRoutes.bookmarkedStoriesRoute)}
                element={<BookmarkedStories />}
              />
              <Route
                path={getAbsolutePath(Path.privateRoutes.privateDirectoryRoute)}
                element={<PrivateDirectory />}
              />
              <Route
                path={getAbsolutePath(Path.privateRoutes.myQueriesRoute)}
                element={<MyQueries />}
              />
            </Route>
            <Route
              onUpdate={() => window.scrollTo(0, 0)}
              path="/"
              element={<MainTheme className="" />}>
              <Route path={Path.privateRoutes.chatRoute} element={<Chat />} />
            </Route>
          </Route>

          <Route path="*" element={<Pagenotfound />} />
        </Routes>
        {pathname === "/" || pathname === "/home" ? <QuotePop initialData={initialData} /> : null}
        <QuoteModal />
      </Suspense>
    </div>
  );
}
export default MyRouts;
